import React, { useState } from 'react';

import { Box, Icon, Pressable } from '@rbilabs/universal-components';
import { Typography, withTypography } from 'ucl/components/text/Typography';

import { A11yWrapper } from 'components/a11y-wrapper';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import theme from './theme';

const PhoneNumberInformation = withTypography({
  variant: 'copyTwo',
  color: theme.phoneNumberInformationColor,
  textAlign: 'center',
  fontSize: 'xs',
  mt: '$3',
});

const PhoneNumberToggle = Pressable.withConfig({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
});

const PhoneAddressInformationToggle = () => {
  const [visible, setVisible] = useState(false);

  return (
    <Box marginBottom="$3">
      <PhoneNumberToggle onPress={() => setVisible(!visible)}>
        <Typography variant="copyTwo" bold>
          {t('whyDoYouNeedMyPhoneNumber')}
        </Typography>
        <Icon
          variant={!visible ? 'select' : 'collapse'}
          color={getDesignToken('icon-default')}
          width="24px"
          {...hiddenAccessibilityPlatformProps}
        />
      </PhoneNumberToggle>
      {visible && (
        <A11yWrapper>
          <PhoneNumberInformation testID="phoneNumberDisclaimer">
            {t('deliveryPhoneDisclosure')}
          </PhoneNumberInformation>
        </A11yWrapper>
      )}
    </Box>
  );
};

export default PhoneAddressInformationToggle;
